var alignment_default = {
  "alignLeft": "_9X-Vd",
  "textWrapNowrap": "SFW5w",
  "alignRight": "ApVna",
  "alignCenter": "kEIqO",
  "sizeFullWidth": "pMAAz",
  "renderedInTable": "c0C-z",
  "sizeOriginal": "E4Lvv",
  "sizeContent": "-FK4X",
  "sizeSmall": "SK8Zj",
  "sizeSmallCenter": "iYzji",
  "flex": "WzMVb",
  "LEFT": "s2NVN",
  "CENTER": "D2OxI",
  "RIGHT": "UYtMB",
  "AUTO": "YY-zb",
  "JUSTIFY": "jmBhI"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
